import React from "react";
import { Switch, Redirect } from "react-router-dom";

import {
  RouteWithLayout,
  PublicRouteWithLayout,
  PrivateRouteWithLayout,
} from "./components";
import {
  Main as MainLayout,
  Minimal as MinimalLayout,
  MainWithSidebar,
} from "./layouts";

import {
  Home as HomePage,
  About as AboutPage,
  NotFound as NotFoundPage,
  Login,
  ForgetPassword,
  SetPassword,
  RequestScreens,
} from "./pages";
import ForemanRoutes from "./Foreman-Routes/Routes";

const Routes = () => {
  //------------------>>ReRender changes on resize window
  // It fixed problem which are accours due to screen resizes
  const [dimensions, setDimensions] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  React.useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }
    window.addEventListener("resize", handleResize);
  }, []);
  ///////////////////////////////////////////////////////
  return (
    <Switch>
      <Redirect exact from="/" to="/login" />
      {/* <Login /> */}
      <PublicRouteWithLayout
        component={Login}
        exact
        layout={MinimalLayout}
        path="/login"
      />
      <PublicRouteWithLayout
        component={ForgetPassword}
        exact
        layout={MinimalLayout}
        path="/forget-password"
      />
      <PublicRouteWithLayout
        component={SetPassword}
        exact
        layout={MinimalLayout}
        path="/set-forget-password/:token"
      />
      <PrivateRouteWithLayout
        component={ForemanRoutes}
        layout={MainWithSidebar}
        path="/salesman"
      />

      <PrivateRouteWithLayout
        component={RequestScreens}
        exact
        layout={MainLayout}
        path="/create-request"
      />

      <RouteWithLayout
        component={NotFoundPage}
        exact={false}
        layout={MinimalLayout}
        path="/"
      />

      {/* <RouteWithLayout
        component={LoginPage}
        exact
        layout={MinimalLayout}
        path="/login"
      />
      <RouteWithLayout
        component={HomePage}
        exact
        layout={MainLayout}
        path="/home"
      />
      <RouteWithLayout
        component={AboutPage}
        exact
        layout={MainLayout}
        path="/about"
      />
      <RouteWithLayout
        component={NotFoundPage}
        exact={false}
        layout={MinimalLayout}
        path="/"
      /> */}
    </Switch>
  );
};

export default Routes;
